export default "__VITE_ASSET__Cb$LSHT6__"